module.exports = __webpack_public_path__ + "static/media/DeleteKeyFrame.bcb8bb65.svg";